import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AvaliacaoForm from './pages/AvaliacaoForm';
import AvaliacaoSucesso from './pages/AvaliacaoSucesso';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminAvaliacoes from './pages/AdminAvaliacoes';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<AvaliacaoForm />} />
          <Route path="/sucesso" element={<AvaliacaoSucesso />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/avaliacoes" element={<AdminAvaliacoes />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
